export interface DecodedRaster {
  width: number;
  height: number;
  rgba: Uint8ClampedArray;
}

/** Decodes a PNG/JPEG Blob into raw RGBA pixels using the browser's built-in decoder (fully offline, no network). */
export async function decodeImageToRgba(blob: Blob): Promise<DecodedRaster> {
  const bitmap = await createImageBitmap(blob);
  const { width, height } = bitmap; // capture before close() neuters the bitmap (zeroes width/height)
  const canvas = new OffscreenCanvas(width, height);
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas 2D context unavailable');
  ctx.drawImage(bitmap, 0, 0);
  const imageData = ctx.getImageData(0, 0, width, height);
  bitmap.close();
  return { width, height, rgba: imageData.data };
}

/** Encodes raw RGBA pixels to a PNG or JPEG Blob via canvas (no network, no external encoder). */
export async function encodeRgbaToBlob(rgba: Uint8ClampedArray, width: number, height: number, format: 'png' | 'jpeg', quality = 0.92): Promise<Blob> {
  const canvas = new OffscreenCanvas(width, height);
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas 2D context unavailable');
  const imageData = new ImageData(rgba, width, height);
  ctx.putImageData(imageData, 0, 0);
  return canvas.convertToBlob({ type: format === 'png' ? 'image/png' : 'image/jpeg', quality: format === 'jpeg' ? quality : undefined });
}

export async function blobToArrayBuffer(blob: Blob): Promise<ArrayBuffer> {
  return blob.arrayBuffer();
}
